const awsmobile =  {
    "aws_appsync_graphqlEndpoint": "https://companyapidev.rovelabs.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "null",
};
export default awsmobile;